/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * inojin-stg-api
 * OpenAPI spec version: 1.0.0
 */

/**
 * 性別
 */
export type PatientModelDTOGender = typeof PatientModelDTOGender[keyof typeof PatientModelDTOGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientModelDTOGender = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
} as const;
